var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83341 0.334717H1.50008C0.766748 0.334717 0.173415 0.934717 0.173415 1.66805L0.166748 12.3347C0.166748 13.068 0.760081 13.668 1.49341 13.668H9.50008C10.2334 13.668 10.8334 13.068 10.8334 12.3347V4.33472L6.83341 0.334717ZM9.50008 12.3347H1.50008V1.66805H6.16675V5.00138H9.50008V12.3347ZM2.83341 9.00805L3.77341 9.94805L4.83341 8.89472V11.668H6.16675V8.89472L7.22675 9.95472L8.16675 9.00805L5.50675 6.33472L2.83341 9.00805Z",
    fill: "#8DC640"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDoc);
export default __webpack_public_path__ + "static/media/uploadDoc.76b949b683cdc7040a8cda665332f36d.svg";
export { ForwardRef as ReactComponent };